function closeComps(){
  window.jsx.evalScript(
    "@JSXBIN@ES@2.0@MyBbyBn0AEJBnASzEjDjPjNjQByBXzKjBjDjUjJjWjFiJjUjFjNCfXzHjQjSjPjKjFjDjUDfjzDjBjQjQEfnftJCnAEXzMjPjQjFjOiJjOiWjJjFjXjFjSFfVBfyBnfIEbyFn0ABJFnAEXzOjFjYjFjDjVjUjFiDjPjNjNjBjOjEGfjEfRBEXzRjGjJjOjEiNjFjOjViDjPjNjNjBjOjEiJjEHfjEfRBFeFiDjMjPjTjFffffAUzChGhGICzChBhdJXCfXDfjEfnnbCzKjJjOjTjUjBjOjDjFjPjGKXCfXDfjEfjzIiDjPjNjQiJjUjFjNLfnnnnJInAEXFfVBfyBnfABB40BiAABAzAMByB"
  );
}

export default closeComps;
